import React from "react";
import _ from "lodash";
import { Card, Button, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import "./Parents.css";
import { Fade } from "react-reveal";
import history from "../../config/history";
import { openSignUpModal } from "../../actions/generalActions";
import { connect } from "react-redux";
import { getCategoryColour } from "../../utils";

class ParentsCard extends React.Component {
  state = {
    cardHover: false,
  };

  renderTooltip = (props, text) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );

  onBlogClick = (e) => {
    if (this.props.blog?._id) {
      if (!this.props.userStatus?.isLoggedIn) {
        // user not logged in
        if (!this.props.blog.isFreeBlog) {
          // clicked on premium video so ask to login and pay
          // alert("log in and go premium to view this paid content");
          this.props.openSignUpModal();
        } else {
          // clicked on free video so ask to login only
          // alert("log in to view this free content");
          this.props.openSignUpModal();
        }
      } else {
        // user is logged in
        if (this.props.userStatus?.isPremium) {
          // user is premium so play the video
          history.push(`activities/story/${this.props.blog._id}`);
        } else if (
          !this.props.blog.isFreeBlog &&
          !this.props.userStatus?.isPremium
        ) {
          // user not premium and video is not free video ask to buy membership
          this.props.handleShowSubscribeModal();
        } else if (
          this.props.blog.isFreeBlog &&
          !this.props.userStatus?.isPremium
        ) {
          // user not premium but video is free so play the video
          // alert("not premium but watch this free video");
          history.push(`activities/story/${this.props.blog._id}`);
        }
      }
    }
  };

  setCardHover = (val) => {
    this.setState({ cardHover: val });
  };

  render() {
    const lockStyles = this.props.blog.isFreeBlog
      ? {
          width: "4.7rem",
          borderRadius: "10px",
          fontSize: "0.8rem",
          background: "rgba(0, 0, 0, 0.7)",
          color: "#FFF",
        }
      : {
          width: "1.5rem",
          borderRadius: "25%",
          fontSize: "0.9rem",
          background: "rgba(0, 0, 0, 0.7)",
          color: "#FFA500",
        };

    return (
      <div className="parents-story-card-container">
        <div
          className="parents-story-card"
          onMouseEnter={() => this.setCardHover(true)}
          onMouseLeave={() => this.setCardHover(false)}
          onClick={this.onBlogClick}
        >
          <img
            className="parents-story-card-img"
            src={`${this.props.blog.thumbnailLink}`}
            onLoad={this.props.onStoryImgsLoad}
            width="1200"
            height="700"
            alt={`thumbnail for ${this.props.blog.title}`}
          />
          <Badge
            className="parents-card-badge"
            style={{ background: getCategoryColour(this.props.blog.category) }}
          >
            {this.props.blog.category}
          </Badge>
          {(!this.props.userStatus?.isLoggedIn ||
            (!this.props.userStatus?.isPremium &&
              !this.props.blog.isFreeBlog)) && (
            <div className="parents-card-lock-icon" style={lockStyles}>
              {!this.props.blog.isFreeBlog && <i className="fa fa-star"></i>}
              {this.props.blog.isFreeBlog && <div>Free Blog</div>}
            </div>
          )}
          <div className="parents-story-card-overlay">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props, title = this.props.blog.title) => (
                <Tooltip id="button-tooltip" {...props}>
                  {title}
                </Tooltip>
              )}
            >
              <div className="parents-story-card-text">
                <div className="parents-story-card-book-icon">
                  <i className="fa fa-book"></i>
                </div>
                <div className="parents-story-card-text-heading">
                  {this.props.blog.title}
                </div>
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};

export default connect(mapStateToProps, { openSignUpModal })(ParentsCard);
